import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Home from '../views/Home.vue';
import Products from '../views/Products.vue';
import PreSelectPolicy from '../views/PreSelectPolicy.vue';
import About from '../views/About.vue';
import { AxaRamosInfo } from '../utils/constants';

Vue.use(VueRouter);

// Dynamic routes for products pages
const ramosRoutes = mapRoutes(AxaRamosInfo);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      store.commit('setRegister', null);
      store.commit('setValidateTokens', false);
      store.commit('setComunicanteContacto', null);
      next();
    }
  },
  {
    path: '/propertyCasualty',
    name: 'P&C',
    component: () => import(/* webpackMode: "eager" */ '../views/PropertyCasualty.vue')
  },
  {
    path: '/Transporte',
    name: 'Transporte',
    component: () => import(/* webpackMode: "eager" */ '../views/Transporte.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAuthenticated) {
        next({ name: 'Home' });
      } else {
        next();
      }
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAuthenticated) {
        next({ name: 'Home' });
      } else {
        next();
      }
    }
  },
  {
    path: '/info',
    name: 'PreSelectPolicy',
    component: PreSelectPolicy,
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAuthenticated) {
        next({ name: 'Home' });
      } else {
        next();
      }
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About
    // component: () =>
    //   import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  ...ramosRoutes,
  {
    path: '*',
    name: 'NotFound',
    beforeEnter: (to, from, next) => {
      next({ name: 'Home' });
    }
  }
];

//console.log(routes);

// mapear as rotas pelas settings
function mapRoutes(axaRamos) {
  return axaRamos.map(x => ({
    path: x.url,
    name: x.name,
    component: () => {
      return import(/* webpackMode: "eager" */ `../views/${x.name}.vue`);
    },
    beforeEnter: (to, from, next) => {
      // if is authenticate
      // if origin not expected
      if (!store.getters.isAuthenticated) {
        next({ name: 'Home' });
      } else if (from.name !== 'PreSelectPolicy') {
        next({ name: 'Home' });
      } else {
        next();
      }
    }
  }));
  // return newRoutes;
}

const router = new VueRouter({
  routes
});

export default router;
